import { render, staticRenderFns } from "./ExpirationIcon.vue?vue&type=template&id=7a5ca977&scoped=true"
import script from "./ExpirationIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpirationIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ExpirationIcon.vue?vue&type=style&index=0&id=7a5ca977&prod&scoped=true&lang=css"
import style1 from "./ExpirationIcon.vue?vue&type=style&index=1&id=7a5ca977&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5ca977",
  null
  
)

export default component.exports